import { render, staticRenderFns } from "./GResetPasswordStep1.vue?vue&type=template&id=57f30af6&"
import script from "./GResetPasswordStep1.vue?vue&type=script&lang=ts&"
export * from "./GResetPasswordStep1.vue?vue&type=script&lang=ts&"
import style0 from "./GResetPasswordStep1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports